module.exports = __webpack_public_path__ + "img/chanp_nr@3x.d3410350.png";